<template>
    <div class="xsListDiv">
        <div class=" head">
            <div class="head-left" @click="$router.go(-1)"><van-icon name="arrow-left" /></div>
            <div class="head-title">学术</div>
        </div>
        <van-row>
            <van-col span="12" @click="showL = true">条件筛选</van-col>
        </van-row>
        <p class="count" v-if="cites">
            <span style="color:#4fa1a4;margin-bottom:0.5rem; display: block;">{{ $store.state.citedTitle }} </span> 找到约{{ totalNum }}条相关结果
        </p>
        <p class="count" v-else>为您检索到{{ totalNum }}条数据</p>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item, i) in list" :key="i">
                <div class="title">
                    <h3 @click="detail(item.title, item.titleHref, item.source, item.year, item.author)">
                        <a>
                            {{ i + 1 }}. <span>{{ item.title }}</span>
                        </a>
                    </h3>
                </div>
                <div class="info">
                    <p v-if="item.author" class="author">{{ item.author }}</p>
                    <p v-if="item.source" class="periodical">{{ item.source }}</p>
                    <p v-if="item.year" class="year">{{ item.year }}</p>
                </div>
                <!--  -->
                <span v-if="item.citedNum" class="cited" @click="getCitedInfo(item.cites, item.title)"> 被引量{{ item.citedNum }}</span>
                <div v-if="item.ab" v-html="item.ab" class="cont"></div>
                <div class="allurl">
                    <span class="laiy" v-if="(item.type == 1 && item.versionList != null) || (item.type == 0 && item.cluster != null)">
                        <img src="@/assets/allsearch/lianjie.png" alt="" />
                        <span
                            class="all"
                            :data-vers="item.versionList"
                            :data-clus="item.cluster"
                            :data-type="item.type"
                            @click="handleAllVersion($event)"
                            :data-index="i"
                            >查看来源</span
                        >
                    </span>
                    <span
                        class="full_t"
                        @click="apply(item.cluster, item.titleHref, item.source, item.year, item.author, item.title)"
                        v-if="item.fullPermission"
                    >
                        <img src="@/assets/allsearch/quanwen.png" />申请全文
                    </span>
                </div>
                <div class="version">
                    <span v-for="(itemV, indexV) in versionData[i]" :key="indexV">
                        <i v-if="indexV != 0">|</i>
                        <a href="javascript:;" @click="versionView(itemV.url)">{{ itemV.name }}</a>
                    </span>
                </div>
            </van-cell>
        </van-list>

        <van-popup v-model="showL" position="left" get-container="#app" class="xs-van-popup-left">
            <van-cell title="分组浏览" class="title" />
            <van-cell data-id="1" @click="sortP($event)" :class="{ active: activeP == '1' }">
                按日期排序
            </van-cell>
            <van-cell data-id="0" @click="sortP($event)" :class="{ active: activeP == '0' }">
                按相关度排序
            </van-cell>
            <van-cell>
                <p>时间筛选</p>
                <input type="text" v-model="as_ys" />
                -
                <input type="text" v-model="as_ye" />
                <van-button type="info" @click="yearFun()">确&nbsp;定</van-button>
            </van-cell>
        </van-popup>
    </div>
</template>

<script>
import api from "@/request/api/search.js";
import { Toast } from "vant";
export default {
    data() {
        return {
            showL: false,
            loading: false, // 列表load
            finished: false, // 列表加载完
            data: {},
            list: [], // 列表数据
            totalNum: 0, // 数据总数
            versionData: [], // 查看来源
            as_ys: "", // 筛选年份
            as_ye: "", // 筛选年份
            activeP: "", // 筛选选中
            cites: false
        };
    },
    created() {},
    mounted: function() {
        this.$store.dispatch("actionsHead", { type: false, title: "学术", iconType: true });
        if (this.$route.query.cites != undefined) {
            this.cites = true;
        } else {
            this.cites = false;
        }
        this.data = this.$route.query;
        this.data.page = 0;
    },
    methods: {
        onLoad() {
            this.showL = false;
            this.data.page = this.data.page + 1;
            api[this.cites ? "xsCites" : "xsSearch"](this.data).then((res) => {
                if (res.code == 0) {
                    this.totalNum = res.data.total;
                    if (this.data.page == 1) {
                        this.list = res.data.searchList;
                    } else {
                        this.list = this.list.concat(res.data.searchList);
                    }
                    this.loading = false;
                    if (this.list.length >= res.data.total) {
                        this.finished = true;
                    }
                } else {
                    Toast(res.msg);
                }
            });
        },
        detail(title, titleHref, source, year, author) {
            let data = {
                title: title,
                title_href: titleHref,
                year: year,
                author: author,
                source: source,
                platform: 2
            };
            var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g"); // 中文
            if (reg.test(title)) {
                api.xsDetail(this.$qs.stringify(data)).then((res) => {
                    if (res.code == 0) {
                        if (res.data.indexOf("google.com") != -1) {
                            Toast("很抱歉,本篇文献暂无资源.");
                        } else {
                            if (localStorage.getItem("access-user") != undefined) {
                                window.location.href =
                                    res.data + (res.data.indexOf("?") != -1 ? "&" : "?") + "token=" + localStorage.getItem("access-user");
                            } else {
                                window.location.href = res.data;
                            }
                            return false;
                        }
                    }
                });
            } else {
                Toast("很抱歉,本篇文献暂无资源.");
            }
        },
        getCitedInfo(val, title) {
            this.$store.dispatch("actionsCitedTitle", title);
            this.$router.push({
                path: "/xsList",
                query: {
                    cites: val
                }
            });
        },
        handleAllVersion(e) {
            var versions = e.target.getAttribute("data-vers") ? e.target.getAttribute("data-vers") : [];
            var cluster = e.target.getAttribute("data-clus") ? e.target.getAttribute("data-clus") : "";
            var data = {
                0: { cluster: cluster, platform: 2 },
                1: { versions: versions, platform: 2 }
            };
            api.xsVersion(this.$qs.stringify(data[e.target.getAttribute("data-type")])).then((res) => {
                if (res.code == 0) {
                    var ind = e.target.getAttribute("data-index");
                    this.$set(this.versionData, ind, res.data);
                }
            });
        },
        apply(cluster, titleHref, source, year, author, title) {
            api.xsApply(
                this.$qs.stringify({
                    cluster: cluster,
                    title_href: titleHref,
                    source: source,
                    year: year,
                    author: author,
                    title: title,
                    versions: []
                })
            ).then((res) => {
                if (res.code == 0) {
                    api.enAddcase([
                        {
                            title: res.data.title,
                            author: res.data.author,
                            sourcefrom: res.data.sourcefrom,
                            year: res.data.year,
                            doi: res.data.doi,
                            web: res.data.web,
                            url: res.data.url,
                            pmid: res.data.pmid,
                            myid: res.data.myid,
                            jid: res.data.jid,
                            pmidNcNlmId: res.data.jid,
                            sourcecode: "xueshu"
                        }
                    ]).then((res) => {
                        Toast(res.data.result);
                    });
                } else {
                    Toast(res.msg);
                }
            });
        },
        versionView(url) {
            window.location.href = url;
        },
        sortP(e) {
            this.activeP = e.target.getAttribute("data-id");
            this.data.sort = e.target.getAttribute("data-id");
            this.data.page = 0;
            this.onLoad();
        },
        yearFun() {
            var SY = this.as_ys;
            var EY = this.as_ye;
            if (SY == "" || SY == null || SY == undefined || EY == "" || EY == null || EY == undefined) {
                Toast("请输入筛选时间");
                return false;
            } else if (SY.length != 4 || EY.length != 4) {
                Toast("请输入正确的时间");
                return false;
            } else if (SY > EY) {
                Toast("请输入正确的时间");
                return false;
            } else {
                this.data.as_ys = SY;
                this.data.as_ye = EY;
                this.data.page = 0;
                this.onLoad();
            }
        }
    }
};
</script>
<style lang="less">
.xsListDiv {
    .head {
        background-color: #3187b6;
        .head-left .van-icon,
        .head-title {
            color: #fff;
            font-size: 1.2rem;
        }
    }
    .count {
        padding: 0.53333rem 0.85333rem 0;
        color: #9a9a9a;
    }
    .van-row {
        height: 2.5rem;
        padding: 0.7rem 0;
        background: #fff;
        border-bottom: 0.05333rem solid #e3e3e3;
        .van-col--12 {
            color: #09718b;
            padding-left: 0.8333rem;
            text-align: left;
        }
    }
    .van-list {
        background-color: #f3f3f3;
        .van-cell {
            background-color: #fff;
            margin-bottom: 0.5rem;
            padding: 1rem 0.5rem;
            font-size: 0.9rem;
            h3 {
                font-size: 1.1rem;
                margin-bottom: 0;
                overflow: hidden;
                span,
                a {
                    color: #0c60a3 !important;
                }
                a {
                    width: 95%;
                    min-height: 1.5rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
            .cited {
                color: #1a7ca9;
                cursor: pointer;
                font-size: 0.9rem;
                margin: 0.3rem 0;
                display: block;
            }
            .info {
                margin: 0.5rem 0 0 0;
                line-height: 1.4rem;
            }

            .cont {
                margin: 2px 0;
                line-height: 1rem;
                color: #a9a7a7;
                height: 2.6rem;
                overflow: hidden;
                line-height: 1.3rem;
            }

            .allurl {
                margin-top: 0.3rem;
                color: #3187b6;
                a {
                    color: #3187b6;
                }
                .laiy {
                    margin-right: 1rem;
                }
                img {
                    vertical-align: -0.1rem;
                }
            }
            .version {
                margin-top: 0.5rem;
                i {
                    font-size: 0.7rem;
                    margin: 0 0.3rem;
                }
                a {
                    // color: #777;
                    color: #3187b6;
                }
            }
        }
    }
}
.xs-van-popup-left {
    width: 50%;
    height: 100%;
    flex-direction: column;
    > * {
        display: block;
    }
    .title {
        padding: 20px;
        font-size: 1rem;
    }
    // > p.active {
    //     color: red;
    // }
    input {
        width: 45%;
        display: inline-block;
        font-size: 0.8rem;
        height: 2rem;
        padding: 10px 20px;
        border: 0px;
        border-bottom: 1px solid #dedede;
    }
    button {
        display: block;
        margin-top: 1rem;
        padding: 0 1rem;
        background: #3ba9e6;
        color: #fff;
        border-radius: 5px;
    }
}
</style>
